import {
  TIMESHEET_ADMIN_VIEW_EMPLOYEE_IDS,
  getLoggedInUserId,
  getUserRole,
} from "./timesheetAccess";

/**
 * Same allowlisted employees as timesheet admin view:
 * HRMS / Leaves admin-style access without changing user_role to admin.
 */
export const HRMS_ADMIN_VIEW_EMPLOYEE_IDS = [
  ...TIMESHEET_ADMIN_VIEW_EMPLOYEE_IDS,
];

export function isHrmsAdminViewEmployee(userId = getLoggedInUserId()) {
  return HRMS_ADMIN_VIEW_EMPLOYEE_IDS.includes(String(userId || "").trim());
}

/** Full admin HRMS/Leaves capabilities (approve, all employees, admin tools). */
export function hasHrmsAdminAccess(userId = getLoggedInUserId()) {
  return getUserRole() === "admin" || isHrmsAdminViewEmployee(userId);
}
